import Vimeo from "@u-wave/react-vimeo"
import YouTube from "@u-wave/react-youtube"
import { ActionButton, ActionButtonAlt, GbiBridged, LinkButtonAlt } from "Components"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import styled from "styled-components"
import { Gap, Subtitle, Title } from "Styles"
import { theme } from "Theme"

const Wrapper = styled.div`

  color: ${({ dark }) => (dark ? theme.colors.white.base : theme.colors.black.base)};
  background: ${(props) => (props.backgroundColor ? props.backgroundColor : theme.colors.background.white)};
  ${(props) => (props.background ? `background-image: url(${props.background});` : "")}
  ${(props) => (props.background ? `box-shadow: inset 0 120px 64px -64px #fff;` : "")}
  ${(props) =>
        props.background
            ? `background-repeat: no-repeat;background-size: cover;background-position: bottom;background-attachment: fixed;`
            : ""}
  ${(props) => (props.image && (!props.vimeoId || !props.youtubeId) ? (!props.dark ? "" : "") : "")}
  ${(props) => (props.vimeoId || props.youtubeId ? "margin-top: 3rem;" : "")}
  min-height: ${(props) => (props.size === "tiny" ? "40px;" : props.size === "medium" ? "100px;" : "360px;")};
  position: relative;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  overflow: ${({ overflow }) => (overflow ? "visible" : "hidden")};
`

const Content = styled.div`
  color: inherit;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 3;
  margin: 0 auto;
  padding: ${(props) => (props.size === "tiny" ? "1rem" : props.size === "medium" ? "2rem" : "4rem")} 1rem;
  max-width: ${theme.layout.base};
  min-height: ${(props) => (props.size === "tiny" ? "40px;" : props.size === "medium" ? "100px;" : "360px;")};

  display: flex;
  flex-direction: column-reverse;

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    ${({ hero }) => (hero ? `margin-top: -4rem;` : `margin: 0 auto;`)};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }

  // grid-area: 1 / 1 / auto / auto;
  // gridTemplateColumns: "60% 40%",
  // gridTemplateRows: "400px",
  position: relative;
  place-items: center;
  // display: grid;
`

const SubContent = styled.div`
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Video = styled.div`
  color: inherit;
  position: relative;
  height: 260px;
  width: 100%;
  z-index: 3;
  max-width: ${theme.layout.base};
  .video-iframe {
    iframe {
      width: 100%;
      background: #000;
      border-radius: ${theme.borderRadius.ui};
      box-shadow: ${theme.shadow.feature.big.default};
    }
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    position: absolute;
    top: -136px;
    .video-iframe {
      iframe {
        border-radius: ${theme.borderRadius.ui};
        height: 324px;
      }
    }
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Logo = styled.div`
  color: inherit;
  position: relative;
  z-index: 3;
  max-width: ${theme.layout.base};
  margin-bottom: 2rem;
  width: 100%;
  .gatsby-image-wrapper {
    height: ${(props) => (props.size ? props.size : "110px")};
    img {
      object-fit: contain !important;
      object-position: center left !important;
      height: ${(props) => (props.size ? props.size : "110px")};
      margin: 0;
    }
  }

  @media (min-width: ${theme.breakpoints.s}) {
    .gatsby-image-wrapper {
      img {
        // object-fit: contain !important;
        // height: ${(props) => (props.size ? props.size : "110px")};
        // margin:0;
      }
    }
  }

  @media (min-width: ${theme.breakpoints.m}) {
    width: 100%;
    margin-bottom: 0;
    .gatsby-image-wrapper {
      img {
        object-position: center right !important;
      }
    }
  }
`

const SectionOptions = ({
    hero,
    track,
    size,
    dark,
    grid,
    image,
    background,
    backgroundColor,
    logo,
    logoSize,
    title,
    subtitle,
    cta_url1_text,
    cta_url1,
    cta_url2_text,
    cta_url2,
    cta_action1,
    cta_action1_text,
    cta_action2,
    cta_action2_text,
    youtubeId,
    vimeoId,
    children,
    overflow,
}) => {
    return (
        <>
            {(vimeoId || youtubeId) && <Gap />}
            <Wrapper
                dark={dark ? 1 : undefined}
                size={size}
                image={image}
                backgroundColor={backgroundColor}
                background={background}
                youtubeId={youtubeId}
                vimeoId={vimeoId}
                style={{ display: "grid" }}
                overflow={overflow ? 1 : undefined}>
                <GbiBridged alt={""} title={title} image={image} formats={["auto", "webp", "avif"]} layout="fullWidth">
                    <Content grid={grid} size={size} logo={logo} hero={hero}>
                        <>
                            <SubContent>
                                {title && title !== "null" && <Title className={!subtitle ? "mb-0" : ""}>{title}</Title>}
                                {subtitle && subtitle !== "null" && <Subtitle className={!children ? "mb-0" : ""}>{subtitle}</Subtitle>}
                                {children && children}
                                {(cta_action1_text || cta_action2_text || cta_url1_text || cta_url2_text) && (
                                    <div style={{ marginTop: "1rem" }}>
                                        {cta_action1 && cta_action1_text && cta_action1_text !== "null" && (
                                            <ActionButton onClick={cta_action1} track={track} title={`${title} | ${cta_action1_text}`}>
                                                {cta_action1_text}
                                            </ActionButton>
                                        )}
                                        {cta_action2 && cta_action2_text && cta_action2_text !== "null" && (
                                            <ActionButtonAlt onClick={cta_action2} track={track} title={`${title} | ${cta_action2_text}`}>
                                                {cta_action2_text}
                                            </ActionButtonAlt>
                                        )}
                                        {cta_url1 && cta_url1_text && cta_url1_text !== "null" && (
                                            <LinkButtonAlt to={cta_url1} track={track} title={`${title} | ${cta_url1_text}`}>
                                                {cta_url1_text}
                                            </LinkButtonAlt>
                                        )}
                                        {cta_url2 && cta_url2_text && cta_url2_text !== "null" && (
                                            <LinkButtonAlt to={cta_url2} track={track} title={`${title} | ${cta_url2_text}`}>
                                                {cta_url2_text}
                                            </LinkButtonAlt>
                                        )}
                                    </div>
                                )}
                            </SubContent>
                            {(vimeoId || youtubeId) && (
                                <div style={{ position: "relative", padding: "90px 0" }}>
                                    <Video>
                                        {vimeoId && !youtubeId && (
                                            <div className="">
                                                <Vimeo
                                                    video={vimeoId}
                                                    autoplay={false}
                                                    height={260}
                                                    volume={1}
                                                    loop={true}
                                                    background={false}
                                                    controls={true}
                                                    className="video-iframe"
                                                />
                                            </div>
                                        )}
                                        {!vimeoId && youtubeId && (
                                            <div className="">
                                                <YouTube
                                                    video={youtubeId}
                                                    autoplay={false}
                                                    height={320}
                                                    volume={1}
                                                    loop={0}
                                                    background={false}
                                                    controls={true}
                                                    className="video-iframe"
                                                    showRelatedVideos={false}
                                                />
                                            </div>
                                        )}
                                    </Video>
                                </div>
                            )}
                            {logo && (
                                <Logo size={logoSize}>
                                    <GatsbyImage alt={""} image={logo} />
                                </Logo>
                            )}
                        </>
                    </Content>
                </GbiBridged>
            </Wrapper>
        </>
    )
}

export default SectionOptions
